import { TableCell, tableCellClasses, TableRow } from '@mui/material';
import { styled } from '@mui/material/styles';

/***********************************Master Styles***********************************/
const h2PageTitle = {fontFamily: 'Roboto', fontSize: "30px", fontWeight: 900, flexGrow:1}

const masterMargin = {pl:'4%', pt:'1.5%', pr:'4%', pb: '4%'}

const tablePadding = { pt: '2%', pb: '2%' }

const pBodyText = { fontFamily: 'Roboto', fontSize: '16px' , whiteSpace: 'pre-line'}

const h1ApplicationTitle = { 
    fontFamily: 'Roboto',
    pt: "1%", 
    fontSize: '22px', 
    flexGrow: 1, 
    verticalAlign: "center",
    paddingTop: '20px', //alligning it to the center doesn't actually center it
};

const h3SectionTitle = { fontFamily: 'Roboto', fontSize: "22px", fontWeight: 300 };

const h4InformationGroupHeader = { fontFamily: 'Roboto', fontSize: "18px", fontWeight: 700 };

const smallLegalText = { fontFamily: 'Roboto', fontSize: "12px", fontWeight: 400 };


/*********************************** EnhancedTable.js ***********************************/
const deleteCancel = {
    "&:hover": {
        backgroundColor: 'transparent !important'
    },
    border: '1px solid', backgroundColor: '#FFFFFF !important', color: '#0072CE',
    marginLeft: 'auto', pl: '3%', pr: '3%'
}
const deleteConfirm = {
    "&:hover": {
        backgroundColor: '#0072CE !important'
    },
    backgroundColor: '#0072CE !important', color: '#FFFFFF', marginLeft: 'auto',
    pl: '3%', pr: '3%'
}
const modalSx = {
    fontSize: "14px",
    marginTop: '15%',
    marginBottom: '15%',
    marginLeft: '30%',
    marginRight: '30%',
    padding: '3%',
    backgroundColor: '#FAFAFA',
    '& input': {
        textAlign: 'center',
        color: 'black',
        fontWeight: 500
    },
    align: 'center',
}
const snackbars = {
    pt: "10%",
    width: "50%"
}

/*********************************** AdminMaintenanceTable.js ***********************************/
const maintenanceTable = {
    paddingLeft: '10vw',
    paddingRight: '10vw',
    paddingBottom: '30px',
    width: 'auto',
    overflow: 'hidden',
}

/*********************************** AdminDropdown.js ***********************************/
const linkSX = { alignItems: 'center', display: 'center', pl: '2%', pr: '2%' };
const menuItemSx = { fontSize: '14px' }
const selectSx = {
    "&:hover": {
        backgroundColor: '#00439D',
    },
    height: "100%",
    width: "100%",
    fontSize: "14px",
    borderRadius: 0,
    color: 'white',
    '.MuiSelect-icon': {
        color: 'white !important'
    }
};


/*********************************** AlertNotification.js ***********************************/
const alertTypography = { margin: '2%', marginBottom: '0' }

/*********************************** AlertNotificationCard.js ***********************************/
const TypographyDate = { fontSize: 12 }
const TypographyTitle = { fontWeight: '700' }
const TypographySender = { fontSize: 12, fontWeight: 700 }

/*********************************** Footer.js ***********************************/
const engImgSx = {
    height: '20px',
    paddingLeft: '2%',
};
const frenchImgSx = {
    height: '30px',
    marginTop: '-.2%',
    paddingLeft: '2%',
};
const footerCopyright = {
    float: 'right',
    whiteSpace: 'nowrap',
    paddingRight: '2%'
};
const footerVersion = {
    textAlign: 'center',
    fontFamily: 'Roboto',
    fontWeight: 400
};

const footer = {
    position: 'fixed',
    left: '0',
    bottom: '0',
    width: '100vw',
    height: '20px',
    backgroundColor: '#3B3B39',
    color: 'white',
    textAlign: 'center',
    paddingTop: '.5%',
    paddingBottom: '.5%',
    zIndex: '2',
}

/*********************************** Header.js ***********************************/
const headerLinkSX = {
    "&:hover": {
        backgroundColor: '#00439D',
    },
    alignItems: 'center', display: 'center', width: 'fit-content',
    fontSize: '14px', pl: '2%', pr: '2%'
};
const boxSX = { height: 40, left: 26, top: 26 };

const activeTab = (history, path) => {
    if (history === path) {
        return { backgroundColor: '#00439D' };
    } else if (history === '' && path === 'home') {
        return { backgroundColor: '#00439D' };
    }
};

const headerIcons = { pt: '1%', pr: "2%" }

const appbar = { height: 'static' }

const breadCrumbs = {
    pl: '4%',
    pt: '1.5%',
    fontFamily: 'Roboto',
    fontSize: '14px'
}

const currentBreadCrumb = {
    fontFamily: 'Roboto',
    fontSize: '14px',
    fontWeight: 700
}

const previousBreadCrumb = {
    fontFamily: 'Roboto',
    fontSize: '14px',
    fontWeight: 400
}

/*********************************** LandingSearch.js ***********************************/
const homePageMargin = {pl:'4%', pt:'3%', pb:'20%'} //Specific margin for HomePage (to ensure all pages align)

const searchSxLanding = {
    height: "100%",
    width: "150%",
    fontSize: "14px",
    backgroundColor: '#FAFAFA',
    textAlign: 'center',
    '& input': {
        textAlign: 'center',
        color: 'black',
        fontWeight: 500,
    }
};
const menuItemSxLanding = { height: "100%", width: "100%", fontSize: "14px" };
const selectSxLanding = {
    pl: "2%",
    height: "92%",
    width: "50%",
    fontSize: "14px",
    backgroundColor: '#D9D9D6',
    fontWeight: 400,
    fontFamily: 'Roboto',
    icon: {
        fill: 'black',
    },
};
const buttonSxLanding = { height: "92%", width: "10%", backgroundColor: "#D9D9D6" };
const errorSxLanding = { fontSize: "14px", fontWeight: 700, color: 'red' };

/*********************************** LanguageSelection.js ***********************************/
const langBoxSx = { pl: '2%', pr: '2%', pt: '0%', marginLeft: 'auto', fontSize: '14px', alignItems: 'center' };
const langSelectionLabel = { alignItems: 'center', display: 'center', pb: '0%' }
const langSelectForm = { m: 1, minWidth: 120, pb: '0%' }
const selectLanguage = {
    color: 'white !important',
    '.MuiSelect-icon': {
        color: 'white !important',
    },
    '.MuiSelect-select': {
        color: 'white !important',
        // textAlign: 'center'
    },
    '&:before': {
        borderBottom: '1px solid white !important'
    },
    '&:after': {
        borderBottom: '1px solid white !important'
    }
}


/*********************************** UserSummary.js ***********************************/
const userSummary = {
    height: '50px',
    margin: '5%'
}
const userName = {
    fontSize: '20px',
    padding: '0',
    margin: '0'
}
const userRole = {
    fontSize: '15px',
    paddingTop: '5px',
    margin: '0',
}
const companyAndBAC = {
    fontSize: '15px',
    paddingTop: '3%',
    margin: '0',
}
const userBAC = {
    fontSize: '15px',
    paddingTop: '5px',
    margin: '0'
}

/*********************************** UserIcon.js ***********************************/
const logout = {
    paddingLeft: '1px',
    paddingTop: '75px',
    margin: '5%',
    position: 'relative'
}
const userIconCard = {
    height: '220px',
    outline: '1px solid #F5F5F5'

}
const userPopover = {
    '.MuiPopover-paper': {
        width: '26% !important'
    }
}

/*********************************** AlertNotificationCard.js ***********************************/
const alertCard = {
    height: '350px',
    overflow: 'scroll!important',
    overflowX: 'hidden !important',
    outline: '1px solid #F5F5F5',
}
const alertCardContent = {
    borderBottom: '1px solid black'
}
const chipAlert = {
    position: 'relative',
    left: '95%',
    top: '20px !important',
    backgroundColor: 'transparent'
}
const alertCardLink = {
    textDecoration: 'none !important',
    color: '#000000 !important',
    margin: '0 !important',
}
const popover = {
    '.MuiPopover-paper': {
        width: '26% !important',
        marginTop: '1% !important'
    }
}

/*********************************** LogoutButton.js ***********************************/
const LogoutButton = {
    backgroundColor: '#0072CE',
    color: 'white',
    '&:hover': {
        backgroundColor: '#0072CE'
    }
}

/*********************************** OrderSummaryComponents.js ***********************************/
const chargeToBacOrPrimaryFanLabelh4InformationGroup = { fontFamily: 'Roboto', fontSize: "18px", fontWeight: 700, pl: '3%', pt: '2%' }

const chargeToBacOrPrimaryFanLabelPBody = { fontFamily: 'Roboto', fontSize: '16px', pl: '3%' }

const orderSummaryTextField = {
    width: '100%',
}
const orderSummaryClear = {
    "&:hover": {
        backgroundColor: 'transparent !important'
    },
    border: '1px solid', backgroundColor: '#FFFFFF !important', color: '#0072CE',
    marginLeft: 'auto', pl: '3%', pr: '3%'
}
const orderSummarySearch = {
    "&:hover": {
        backgroundColor: '#0072CE !important'
    },
    backgroundColor: '#0072CE !important', color: '#FFFFFF', marginLeft: 'auto',
    pl: '3%', pr: '3%'
}

const orderSummarySelect = {
    width: '100%',
}


/*********************************** OrderSummary.js ***********************************/
const orderSummaryStack = { pt: "3%", pl: '3%', pr: '4%' };
const orderSummaryStack_2 = { pt: "3%", ml: '5%', pr: '8%' };
const orderSummaryStack_3 = { pt: "3%", pl: '4%', pr: '8%' };
const orderSummaryStack_4 = { pt: "3%", pl: '5%', pr: '3%' };
const orderSummaryStack_5 = { pt: "3%", pl: '4%', pr: '8%' };
const orderSummaryStackButton = { paddingTop: 5, pr: '4%' };

/*********************************** OrderSummaryTable.js ***********************************/
const orderSummaryStickyCell = {
    position: 'sticky',
    backgroundColor: '#F7F7F7',
    zIndex: '1',
    left: '0',
    minWidth: 130,
    borderRight: '1px solid rgba(0,0,0,0.2)',
    borderBottom: '0px',
    height: 50,
}

const orderSummaryTable = {
    marginLeft: 8,
    marginRight: 8,
    marginTop: 5
}

const orderSummaryCell = {
    borderRight: "1px solid rgba(0,0,0,0.2)",
    borderBottom: "0px",
    zIndex: '-1',
    minWidth: 85,
    height: 50
}

const orderSummaryToolbar = {
    position: 'sticky',
    backgroundColor: '#F7F7F7',
    left: '0',
}

const orderSummaryModelLinkStyle = {
    "&:hover": {
        color: '#00439D !important'
    },
    color: '#0072CE', fontSize: '14px', cursor: 'pointer'
}
const orderSummaryAllocationLinkStyle = {
    "&:hover": {
        color: '#00439D !important'
    },
    fontSize: '16px', cursor: 'pointer'
}


/*********************************** AdvancedSearched.js ***********************************/
const advancedSearchStack = { pt: "2%", pl: '3%', pr: '4%' };


/*********************************** OrderRequestList.js ***********************************/

const orderRequestListCell = {
    borderRight: "1px solid rgba(0,0,0,0.2)",
    borderBottom: "0px",
    zIndex: '-1',
    minWidth: 170,
    height: 50
}

const orderRequestListStickyCell = {
    position: 'sticky',
    backgroundColor: '#F7F7F7',
    zIndex: '1',
    left: '0',
    minWidth: 130,
    borderRight: '1px solid rgba(0,0,0,0.2)',
    borderBottom: '0px',
    height: 50,
}

const orderRequestListStickyCell2 = {
    position: 'sticky',
    backgroundColor: 'white',
    zIndex: '1',
    left: '0',
    minWidth: 130,
    borderRight: '1px solid rgba(0,0,0,0.2)',
    borderBottom: '0px',
    height: 50,
}

const orderRequestListHeader = {
    minWidth: 130,
    borderRight: '1px solid rgba(0,0,0,0.2)',
    borderBottom: '0px',
    backgroundColor: '#F7F7F7',
    height: 50
}

const orderRequestListStickyHeader = {
    backgroundColor: '#F7F7F7',
    borderBottom: '0px',
    position: 'sticky',
    zIndex: '1',
    left: '0',
    minWidth: 170,
    borderRight: '1px solid rgba(0,0,0,0.2)',
    height: 50
}

const orderRequestListRow = {
    '&:nth-of-type(even)': {
        backgroundColor: '#F7F7F7',
    }
}

const ordersNotFoundMessage = {
    pt: "1%",
    fontWeight: 200,
    fontSize: '18px',
    flexGrow: 1,
    display: 'flex',
    justifyContent: 'center',
    color: 'red'
}


const advancedSearchSelect = {
    width: '100%',
}

const orderRequestListStackButton = { paddingTop: 2, pr: '4%' };
const orderRequestListButton = {
    "&:hover": {
        backgroundColor: 'transparent !important'
    },
    border: '1px solid', backgroundColor: '#FFFFFF !important', color: '#0072CE',
    marginLeft: 'auto', pl: '3%', pr: '3%'
}


const orderDetailPopUp = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 500,
    bgcolor: 'background.paper',
    boxShadow: 24,
    pt: 3,
    px: 4,
    pb: 3,
};


const orderRequestLinkStyle = {
    "&:hover": {
        color: '#00439D !important'
    },
    cursor: 'pointer',
}


/***********************************  OrderDetailOptionTable.js ***********************************/
const OrderDetailOptionTableCell = {
    borderRight: "1px solid rgba(0,0,0,0.3)",
    borderBottom: "0px",
}

const TableCellHeader = {
    borderRight: "1px solid rgba(0,0,0,0.3)",
    borderBottom: "0px",
    height: 30,
    backgroundColor: '#F7F7F7'
}

/* const OrderDetailHistoryTableCell = {
    borderRight: "1px solid rgba(0,0,0,0.3)",
    borderBottom: "0px",
}

const OrderDetailHistoryTableCellHeader = {
    borderRight: "1px solid rgba(0,0,0,0.3)",
    borderBottom: "0px",
    height: 30,
    backgroundColor: '#F7F7F7'
} */

/****************************************OrderDetail.js**********************************************/
const orderDetailLabels = { fontFamily: 'Roboto', fontSize: "22px", fontWeight: 300, paddingTop: '5%' };
const vehicleInformationLabel = { fontFamily: 'Roboto', fontSize: "22px", fontWeight: 300, paddingLeft: '0%' };
const currentEventLabel = { fontFamily: 'Roboto', fontSize: "22px", fontWeight: 300, paddingLeft: '7%', paddingTop: '2%' };
const shipToLabel = { fontFamily: 'Roboto', fontSize: "16px", fontWeight: 700 }
const shipToValues = { fontFamily: 'Roboto', fontSize: "16px", fontWeight: 400 }
const orderDetailBoxLabel = { fontFamily: 'Roboto', fontSize: "22px", fontWeight: 300, paddingTop: '3%', paddingLeft: '4%' };
const orderDetailBoxMargin = { pl: '4%', pt: '2%', pr: '4%' }
const eventHistoryTableMargin = { pl: '3%', pr: '2%' }
const eventHistoryBoxSizing = { width: '40%', pt: '.5%' }

const orderDetailBoxM3MB8 = { margin: '3%', marginBottom: '8%' }
const orderDetailWidth50percent = { width: '50%' }
const orderDetailWidth60percent = { width: '60%' }
const orderDetailWidth40percent = { width: '40%' }
const orderDetailBoxShadow = { boxShadow: 5, bgcolor: ' #FAFAFA'}
const stackMargin2percent = { margin: '2%' }
const orderDetailWidth33percent = { width: '33%', height: 300 }


/*****************************Loading Spinner *****************************/
const loadingSpinner = { color: 'white' }

const homepageBoxShadow = { backgroundColor: "rgba(255, 255, 255, 0.4)", padding: '10px', borderRadius: '30px'}

export const styles = {
    orderDetailWidth33percent: orderDetailWidth33percent,
    orderDetailLabels: orderDetailLabels,
    stackMargin2percent: stackMargin2percent,
    orderDetailBoxShadow: orderDetailBoxShadow,
    homepageBoxShadow: homepageBoxShadow,
    orderDetailWidth50percent: orderDetailWidth50percent,
    orderDetailWidth60percent: orderDetailWidth60percent,
    orderDetailWidth40percent: orderDetailWidth40percent,
    orderDetailBoxM3MB8: orderDetailBoxM3MB8,

    orderDetailPopUp: orderDetailPopUp,
    advancedSearchStack: advancedSearchStack,
    advancedSearchSelect: advancedSearchSelect,

    orderSummarySelect: orderSummarySelect,
    orderSummaryStackButton: orderSummaryStackButton,
    orderSummaryStack: orderSummaryStack,
    orderSummaryStack_2: orderSummaryStack_2,
    orderSummaryStack_3: orderSummaryStack_3,
    orderSummaryStack_4: orderSummaryStack_4,
    orderSummaryStack_5: orderSummaryStack_5,
    chargeToBacOrPrimaryFanLabelh4InformationGroup:chargeToBacOrPrimaryFanLabelh4InformationGroup,
    chargeToBacOrPrimaryFanLabelPBody: chargeToBacOrPrimaryFanLabelPBody,
    

    alertTypography: alertTypography,
    TypographyDate: TypographyDate,
    TypographyTitle: TypographyTitle,
    TypographySender: TypographySender,
    selectSx: selectSx,
    menuItemSx: menuItemSx,
    linkSX: linkSX,
    deleteCancel: deleteCancel,
    deleteConfirm: deleteConfirm,
    modalSx: modalSx,
    engImgSx: engImgSx,
    frenchImgSx: frenchImgSx,
    footerCopyright: footerCopyright,
    footerVersion: footerVersion,
    headerLinkSX: headerLinkSX,
    boxSX: boxSX,
    h1ApplicationTitle: h1ApplicationTitle,
    activeTab: activeTab,
    headerIcons: headerIcons,
    appbar: appbar,
    searchSxLanding: searchSxLanding,
    menuItemSxLanding: menuItemSxLanding,
    selectSxLanding: selectSxLanding,
    buttonSxLanding: buttonSxLanding,
    
    errorSxLanding: errorSxLanding,
    langBoxSx: langBoxSx,
    langSelectionLabel: langSelectionLabel,
    langSelectForm: langSelectForm,
    selectLanguage: selectLanguage,

    snackbars: snackbars,
    footer: footer,
    maintenanceTable: maintenanceTable,
    userSummary: userSummary,
    userName: userName,
    userRole: userRole,
    companyAndBAC: companyAndBAC,
    userBAC: userBAC,
    logout: logout,
    userIconCard: userIconCard,
    alertCard: alertCard,
    chipAlert: chipAlert,
    alertCardLink: alertCardLink,
    alertCardContent: alertCardContent,
    popover: popover,
    userPopover: userPopover,
    LogoutButton: LogoutButton,
    orderSummaryTextField: orderSummaryTextField,
    orderSummaryClear: orderSummaryClear,
    orderSummarySearch: orderSummarySearch,
    orderRequestListStickyHeader: orderRequestListStickyHeader,
    orderRequestListCell: orderRequestListCell,
    orderRequestListStickyCell: orderRequestListStickyCell,
    orderRequestListStickyCell2: orderRequestListStickyCell2,
    orderRequestListHeader: orderRequestListHeader,
    orderRequestListRow: orderRequestListRow,
    ordersNotFoundMessage: ordersNotFoundMessage,
    orderRequestListButton: orderRequestListButton,
    orderRequestListStackButton: orderRequestListStackButton,
    OrderDetailOptionTableCell: OrderDetailOptionTableCell,
    TableCellHeader: TableCellHeader,
    orderSummaryTable: orderSummaryTable,
    orderSummaryCell: orderSummaryCell,
    orderSummaryToolbar: orderSummaryToolbar.backgroundColor,
    loadingSpinner: loadingSpinner,
    orderSummaryStickyCell: orderSummaryStickyCell,
    orderSummaryAllocationLinkStyle: orderSummaryAllocationLinkStyle,
    orderSummaryModelLinkStyle: orderSummaryModelLinkStyle,
    orderRequestLinkStyle: orderRequestLinkStyle,
    breadCrumbs: breadCrumbs,


    h2PageTitle: h2PageTitle,
    masterMargin: masterMargin,
    pBodyText: pBodyText,
    h3SectionTitle: h3SectionTitle,
    h4InformationGroupHeader: h4InformationGroupHeader,
    smallLegalText: smallLegalText,
    homePageMargin: homePageMargin,
    tablePadding: tablePadding,
    currentEventLabel: currentEventLabel,
    shipToLabel: shipToLabel,
    shipToValues: shipToValues,
    vehicleInformationLabel:vehicleInformationLabel,
    orderDetailBoxLabel:orderDetailBoxLabel,
    orderDetailBoxMargin:orderDetailBoxMargin,
    eventHistoryTableMargin:eventHistoryTableMargin,
    eventHistoryBoxSizing:eventHistoryBoxSizing,
    currentBreadCrumb:currentBreadCrumb,
    previousBreadCrumb:previousBreadCrumb,
}


/**************************************** TABLE ROW COLOR COMPONENT STYLE **********************************************/

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: '#F7F7F7',
        color: theme.palette.common.black,
        fontSize: 16,
        width: 0,
        fontWeight: 'bold',

        '&:first-of-type': {
            position: 'sticky',
            backgroundColor: 'F7F7F7',
            zIndex: '1',
            left: '0',
            minWidth: 130,
            borderRight: '1px solid rgba(0,0,0,0.2)',
            borderBottom: '0px',
            height: 50,
        }
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,

        '&:nth-of-type(1)': {
            position: 'sticky',
            backgroundColor: 'inherit',
            zIndex: '1',
            left: '0',
            minWidth: 130,
            borderRight: '1px solid rgba(0,0,0,0.2)',
            borderBottom: '0px',
            height: 50,
        },
    }
}));


export const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(even)': {
        backgroundColor: '#F7F7F7',
    },
    '&:nth-of-type(odd)': {
        backgroundColor: 'white',
    },
}));

export const StyledTableCellTotal = styled(TableCell)(({ theme }) => ({
    backgroundColor: '#F7F7F7',
    color: theme.palette.common.black,
    fontSize: 16,
    width: 0,
    fontWeight: 'bold',
    borderTop: '3px double #D9D9D6',

    '&:first-of-type': {    
        position: 'sticky',
        backgroundColor: 'F7F7F7',
        zIndex: '1',
        left: '0',
        minWidth: 130,
        borderRight: '1px solid rgba(0,0,0,0.2)',
        borderBottom: '0px',
        height: 50,
    }

}));
